import { FlexRow } from '@editor/components/utilities/layouts';
import CrownIcon from '@repo/ui/components/Icon/CrownIcon';
import CheckIcon from '@repo/ui/components/Icon/v2/CheckIcon';
import { P2 } from '@repo/ui/components/Typography';
import { themeStyle, useNewThemeActive } from '@repo/ui/theming';

import { FeatureItemProps } from './types';

const FeatureItem: React.FC<FeatureItemProps> = ({
  text,
  isBold,
  isPremium,
}) => {
  const isNewThemeActive = useNewThemeActive();

  return (
    <FlexRow alignItems="center" gap="10px">
      <CheckIcon
        height="17px"
        theme={{
          color: isNewThemeActive
            ? themeStyle.varBlueMedium
            : themeStyle.varBrandMedium,
        }}
      />
      <P2>{isBold ? <strong>{text}</strong> : text}</P2>
      {isPremium && <CrownIcon height="10px" />}
    </FlexRow>
  );
};

export default FeatureItem;
